import * as React from 'react';
import './monthlyFilter.css'
import { Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';

export interface IMonthlyFilterProps {
  changeSelected: (option: IMonthOption) => void;
  options: IMonthOption[]
  selected: IMonthOption
}

export interface IMonthOption {
  lte: number;
  gte: number;
  name: string
}

export interface IMonthlyFilterState {
  toggleFilter: boolean
}

class MonthlyFilter extends React.Component<IMonthlyFilterProps, IMonthlyFilterState> {
  constructor(props: IMonthlyFilterProps) {
    super(props);
    this.state = {
      toggleFilter: false
    }
  }
  public toggleFilter = (selected?) => {
    this.setState((state) => ({
      toggleFilter: !state.toggleFilter
    }))
  }
  public changeAgency = (agencyCode) => (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    this.setState({ toggleFilter: false }, () => this.props.changeSelected(agencyCode))
  }
  public toogle = () => this.setState({ toggleFilter: true })
  public render() {
    return (
      <h3 className={'monthlyFilter'} onClick={this.toogle}>
        {this.props.selected.name}
        <div className={"filter"}>
          <p onClick={this.toogle}>
            <i className="fa fa-filter" aria-hidden="true" />
          </p>
          <Popper className="filterPopper" open={this.state.toggleFilter} transition={true} disablePortal={true}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.toggleFilter}>
                    <MenuList>
                      {(this.props.options).map((option) => {
                        return <MenuItem onClick={this.changeAgency(option)} key={option.name}>{option.name}</MenuItem>
                      })}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>

      </h3>
    );
  }
}

export default MonthlyFilter;